var cov_1s3s4fpl4x = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Table/Checkbox.tsx",
      hash = "dbf983d631b343006c6452d5cab11b018a8af042",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Table/Checkbox.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 16
        }
      },
      "1": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 52
        }
      },
      "2": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 51
        }
      },
      "3": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 29
        }
      },
      "4": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 63
        }
      },
      "5": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 32
        }
      },
      "6": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 65
        }
      },
      "7": {
        start: {
          line: 28,
          column: 45
        },
        end: {
          line: 28,
          column: 55
        }
      },
      "8": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 33,
          column: 5
        }
      },
      "9": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 45
        }
      },
      "10": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 32,
          column: 48
        }
      },
      "11": {
        start: {
          line: 37,
          column: 28
        },
        end: {
          line: 37,
          column: 38
        }
      },
      "12": {
        start: {
          line: 38,
          column: 21
        },
        end: {
          line: 38,
          column: 41
        }
      },
      "13": {
        start: {
          line: 39,
          column: 20
        },
        end: {
          line: 39,
          column: 37
        }
      },
      "14": {
        start: {
          line: 40,
          column: 22
        },
        end: {
          line: 40,
          column: 58
        }
      },
      "15": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 107
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        loc: {
          start: {
            line: 11,
            column: 53
          },
          end: {
            line: 15,
            column: 3
          }
        },
        line: 11
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        loc: {
          start: {
            line: 17,
            column: 22
          },
          end: {
            line: 20,
            column: 3
          }
        },
        line: 17
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        loc: {
          start: {
            line: 22,
            column: 25
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 22
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 56
          },
          end: {
            line: 34,
            column: 3
          }
        },
        line: 27
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 3
          }
        },
        loc: {
          start: {
            line: 36,
            column: 11
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 36
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        }, {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        }],
        line: 29
      },
      "1": {
        loc: {
          start: {
            line: 40,
            column: 22
          },
          end: {
            line: 40,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 40,
            column: 42
          },
          end: {
            line: 40,
            column: 47
          }
        }, {
          start: {
            line: 40,
            column: 50
          },
          end: {
            line: 40,
            column: 58
          }
        }],
        line: 40
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Table/Checkbox.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import { CHANGE_TOPIC } from '../Datum/types';
import Checkbox from '../Checkbox/Checkbox';
import Radio from '../Radio/Radio';

var TableCheckbox =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TableCheckbox, _PureComponent);

  var _super = _createSuper2(TableCheckbox);

  function TableCheckbox(props) {
    var _this;

    _classCallCheck(this, TableCheckbox);

    cov_1s3s4fpl4x.f[0]++;
    cov_1s3s4fpl4x.s[0]++;
    _this = _super.call(this, props);
    _this.handleUpdate = void 0;
    cov_1s3s4fpl4x.s[1]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    cov_1s3s4fpl4x.s[2]++;
    _this.handleUpdate = _this.forceUpdate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TableCheckbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1s3s4fpl4x.f[1]++;
      cov_1s3s4fpl4x.s[3]++;

      _get(_getPrototypeOf(TableCheckbox.prototype), "componentDidMount", this).call(this);

      cov_1s3s4fpl4x.s[4]++;
      this.props.datum.subscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1s3s4fpl4x.f[2]++;
      cov_1s3s4fpl4x.s[5]++;

      _get(_getPrototypeOf(TableCheckbox.prototype), "componentWillUnmount", this).call(this);

      cov_1s3s4fpl4x.s[6]++;
      this.props.datum.unsubscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "handleChange",
    value: function handleChange(_, checked, index) {
      cov_1s3s4fpl4x.f[3]++;

      var _ref = (cov_1s3s4fpl4x.s[7]++, this.props),
          data = _ref.data,
          datum = _ref.datum,
          treeColumnsName = _ref.treeColumnsName;

      cov_1s3s4fpl4x.s[8]++;

      if (checked) {
        cov_1s3s4fpl4x.b[0][0]++;
        cov_1s3s4fpl4x.s[9]++;
        datum.add(data, index, treeColumnsName);
      } else {
        cov_1s3s4fpl4x.b[0][1]++;
        cov_1s3s4fpl4x.s[10]++;
        datum.remove(data, index, treeColumnsName);
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_1s3s4fpl4x.f[4]++;

      var _ref2 = (cov_1s3s4fpl4x.s[11]++, this.props),
          data = _ref2.data,
          datum = _ref2.datum;

      var disabled = (cov_1s3s4fpl4x.s[12]++, datum.disabled(data));
      var checked = (cov_1s3s4fpl4x.s[13]++, datum.check(data));
      var CheckItem = (cov_1s3s4fpl4x.s[14]++, datum.limit === 1 ? (cov_1s3s4fpl4x.b[1][0]++, Radio) : (cov_1s3s4fpl4x.b[1][1]++, Checkbox));
      cov_1s3s4fpl4x.s[15]++;
      return (
        /*#__PURE__*/
        React.createElement(CheckItem, Object.assign({}, this.props, {
          checked: checked,
          disabled: disabled,
          onChange: this.handleChange,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 41,
            columnNumber: 12
          }
        }))
      );
    }
  }]);

  return TableCheckbox;
}(PureComponent);

export { TableCheckbox as default };